module.exports = __webpack_public_path__ + "res/Roboto-Italic-webfont.svg?2adc868d16fac028d5f4edb4c85a7057";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Italic-webfont.svg
// module id = 25
// module chunks = 0